export default {
  title: 'Liefersoft',
  form: {
    company_id: 'ID azienda',
    login: 'Login',
    password: 'Password',
  },
  buttons: {
    save: 'Salva',
    edit: 'Modifica',
    cancel: 'Annulla',
  },
  toasts: {
    error: 'Salvataggio modifiche non riuscito',
    success: 'Modifiche salvate',
  },
  instructions: {
    title: 'Istruzioni di configurazione:',
    steps: {
      1: 'Vai su «Impostazioni» > «Impostazioni programma» > «API/Interfacce».',
      2: 'Aggiungi una piattaforma:\n• Clicca sul pulsante «Piattaforme».\n• Inserisci un nome utente (es. il nome della piattaforma).\n• Clicca su «Salva».',
      3: 'Copia i dati API:\n• Dopo il salvataggio apparirà una finestra con il codice della piattaforma API.\n• Copia i dati visualizzati.',
    },
  },
  connected: {
    title: 'Liefersoft è connesso',
    description: 'Questa integrazione è configurata.',
  },
};
